module.exports = __webpack_public_path__ + "static/media/TN-Women-Bags.9c4d065b.svg";